__turbopack_context__.v({
  "logo": "Navigation-module-scss-module__qD8n8q__logo",
  "logoImage": "Navigation-module-scss-module__qD8n8q__logoImage",
  "navigation": "Navigation-module-scss-module__qD8n8q__navigation",
  "navigationGlobalLink": "Navigation-module-scss-module__qD8n8q__navigationGlobalLink",
  "navigationGlobals": "Navigation-module-scss-module__qD8n8q__navigationGlobals",
  "navigationGlobalsLinks": "Navigation-module-scss-module__qD8n8q__navigationGlobalsLinks",
  "navigationInner": "Navigation-module-scss-module__qD8n8q__navigationInner",
  "navigationMain": "Navigation-module-scss-module__qD8n8q__navigationMain",
  "navigationMainLink": "Navigation-module-scss-module__qD8n8q__navigationMainLink",
  "navigationSection": "Navigation-module-scss-module__qD8n8q__navigationSection",
});
